import { OverviewResponse } from '@bartizo/shared';
import { apiRequest } from './client.js';

/** The landing page's one read (P11.2). */
export const getOverview = (): Promise<OverviewResponse> =>
  apiRequest('/overview', { schema: OverviewResponse });
